module.exports = __webpack_public_path__ + "img/1d6a441.jpg";